import React from "react";
import GlobalStyles from "../components/GlobalStyles";
import App from "../components/App";
import GlobalFonts from "../components/GlobalFonts";

const IndexPage = () => {
  return (
    <>
      <GlobalStyles />
      <GlobalFonts />
      <App />
    </>
  );
};

export default IndexPage;
